import React, { useContext, useState } from 'react';
import { AppContext } from '../context/AppContext';
import RecordingTable from '../components/recordings/RecordingTable';
import RecordingPlayerModal from '../components/recordings/RecordingPlayerModal';

const RecordingsPage = () => {
  const { recordings } = useContext(AppContext);
  const [selected, setSelected] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);

  const handlePlay = (rec) => {
    setSelected(rec);
    setShowPlayer(true);
  };

  const handleDownload = (rec) => {
    if (!rec.video_url) {
      alert('This recording does not have a downloadable media URL stored.');
      return;
    }
    const a = document.createElement('a');
    a.href = rec.video_url;
    a.download = `${rec.title.replace(/\s+/g, '_')}.webm`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div>
      <h3 className="mb-3">Recording List</h3>
      <RecordingTable
        recordings={recordings}
        onPlay={handlePlay}
        onDownload={handleDownload}
      />
      <RecordingPlayerModal
        show={showPlayer}
        recording={selected}
        onClose={() => setShowPlayer(false)}
      />
    </div>
  );
};

export default RecordingsPage;
